// console.log("process.env.NODE_ENV", process.env.NODE_ENV);
// export const TOKEN_ENDPOINT =
//   !process.env.NODE_ENV || process.env.NODE_ENV === "development"
//     ? "http://localhost:3000"
//     : `${window.location.origin}`;
export const TOKEN_ENDPOINT = `${window.location.origin}`;
 